import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import { Redirect } from 'react-router-dom';
import * as categoryAction from './../actionCreators/category';
import * as productAction from './../actionCreators/product';
import { getQueryParam, removeDomainName } from './../utils/helper';
import Spinner from './../CommonComponents/Spinner/Spinner';
let NotFound;
'#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
NotFound = require('./../mobile/components/NotFound/NotFound').default;
'#endif'; // eslint-disable-line
'#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
NotFound = require('./../desktop/containers/NotFound/Loadable').default;
'#endif'; // eslint-disable-line

@provideHooks({
    fetch: ({ location, store: { dispatch } }) => {
        const path = location.pathname;
        const query = location.search.substr(1);
        const pId = getQueryParam(query, 'pId');
        let productID = null;
        let catID = null;
        let getID = null;
        if (pId) {
            productID = pId;
        } else if (path.indexOf('view/id') !== -1) {
            getID = path.match(/([^]*)\/view\/id\/(\d*)/);
            if (path.indexOf('/product') !== -1) {
                productID = getID[2];
            } else {
                catID = getID[2];
            }
        } else if (path.indexOf('/product') !== -1) {
            productID = path.replace(/\D/g, '');
        } else {
            catID = path.replace(/\D/g, '');
        }
        if (catID) {
            dispatch(categoryAction.getCategoryData(catID));
        }
        if (productID) {
            dispatch(productAction.getProductData(productID));
        }
    }
})

class RedisMapping extends Component {
    static propTypes = {
        categoryData: PropTypes.object,
        productData: PropTypes.object
    }

    constructor(props) {
        super(props);
        this.state = {
            showSpinner: true
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ showSpinner: false });
        }, 5000);
    }

    render() {
        const { categoryData, productData, history, dataLocale } = this.props;
        const { showSpinner } = this.state;
        if (categoryData && categoryData.result && categoryData.result.urlPath) {
            return (<Redirect to={`/${categoryData.result.urlPath}`} />);
        }
        if (productData && productData.result && productData.result.url) {
            return (<Redirect to={`${removeDomainName(productData.result.url)}`} />);
        }
        return (
            showSpinner
                ? <Spinner fullpage />
                : <NotFound history={history} dataLocale={dataLocale} />
        );
    }
}

const mapStateToProps = state => ({
    categoryData: state.category.categoryData,
    productData: state.product.productData,
    dataLocale: state.locale
});

function mapDispatchToProps() {
    return {};
}

RedisMapping.defaultProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(RedisMapping);
